import View from '@shared/components/layout-default/layout-default-router-view';

export const referral = [
  {
    path: 'referral',
    component: View,
    children: [
      {
        path: '',
        name: 'referral.index',
        redirect: {
          name: 'referral.user.index'
        }
      },

      {
        path: 'users',
        component: View,
        children: [
          {
            path: '',
            name: 'referral.user.index',
            component: () =>
              import(
                /* webpackChunkName: 'referral' */
                '@referral/pages/referral-users-page'
              ),
            meta: {
              title: {
                code: 'referral.breadcrumb.user.index'
              }
            }
          }
        ]
      },

      {
        path: 'profit',
        component: View,
        children: [
          {
            path: '',
            name: 'referral.profit.index',
            component: () =>
              import(
                /* webpackChunkName: 'referral' */
                '@referral/pages/referral-profit-page'
              ),
            meta: {
              title: {
                code: 'referral.breadcrumb.profit.index'
              }
            }
          }
        ]
      },

      {
        path: 'requests',
        component: View,
        children: [
          {
            path: '',
            name: 'referral.request.index',
            component: () =>
              import(
                /* webpackChunkName: 'referral' */
                '@referral/pages/referral-requests-page'
              ),
            meta: {
              title: {
                code: 'referral.breadcrumb.request.index'
              }
            }
          }
        ]
      }
    ]
  }
];
